import { useParamsSearch } from '@anytag/shared-hooks';
import { MarketplaceInfluencersSearchSchemaType } from '../schemaTypes';

export const useMarketplaceInfluencersFilter = () => useParamsSearch<MarketplaceInfluencersSearchSchemaType>();
